import { ITourProduct } from '../types/ITourProduct';
import { FlightType } from '../types/IFlightType';
import { HotelAvailable } from '../types/IHotelAvailable';
import { ConfirmationType } from '@entities/confirmationType/@/tourProduct';
import { OperatorId } from '@entities/operator/@/tourProduct';

const getTourConfirmationType = (tourProduct: ITourProduct): ConfirmationType | '' => {

    const isTravelataOperator = OperatorId.Travelata.includes(tourProduct.operator?.id || 0);

    if (tourProduct.hotelAvailable === HotelAvailable.all) return ConfirmationType.Quick;
    if (isTravelataOperator && tourProduct.hotelAvailable === HotelAvailable.byRequest) return ConfirmationType.Long;
    if (tourProduct.hotelAvailable === HotelAvailable.byRequest && tourProduct.flightType === FlightType.charter) return ConfirmationType.Long;
    if (tourProduct.hotelAvailable === HotelAvailable.byRequest && tourProduct.flightType === FlightType.regular) return ConfirmationType.Cancel;

    return '';
};

const getToursConfirmationType = (tourProducts: ITourProduct[]): ConfirmationType | '' => {
    const typesConfirmations = tourProducts.map((tourProduct) => getTourConfirmationType(tourProduct));
    if (typesConfirmations.includes(ConfirmationType.Quick)) return ConfirmationType.Quick;
    if (typesConfirmations.includes(ConfirmationType.Long)) return ConfirmationType.Long;
    if (typesConfirmations.includes(ConfirmationType.Cancel)) return ConfirmationType.Cancel;
    return '';
};
export {
    getToursConfirmationType,
    getTourConfirmationType,
};